var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearchSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77802 13.8363C12.0875 13.8363 14.7704 11.1534 14.7704 7.84393C14.7704 4.53444 12.0875 1.85156 8.77802 1.85156C5.46852 1.85156 2.78564 4.53444 2.78564 7.84393C2.78564 11.1534 5.46852 13.8363 8.77802 13.8363Z",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9458 12.3223L15.2952 14.6655",
    stroke: "#1E2948",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.933594)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchSmall);
export default __webpack_public_path__ + "static/media/icon-search-small.54e7ff824c95d95237fdf6b45dc52136.svg";
export { ForwardRef as ReactComponent };